import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hiddenField", "results"];
  static values = { indexPath: String };

  connect() {
    console.log("CharityBase controller connected...");
  }

  search(event) {
    event.preventDefault();
    const searchInput = event.currentTarget;
    const searchValue = searchInput.value;

    if (this.hasIndexPathValue) {
      const url = this.indexPathValue + `?search=${searchValue}`;
      this.resultsTarget.src = url;
      this.resultsTarget.textContent = "Loading search results...";
    }
  }

  select(event) {
    event.preventDefault();
    const selectedCharity = event.currentTarget;
    const charityId = selectedCharity.dataset.charityBaseId;

    console.log("selectedCharity:", selectedCharity);
    console.log("charityId:", charityId);

    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = charityId;
      this.resultsTarget.textContent = "Loading charity record...";
      this.element.requestSubmit();
    }
  }
}
